// Single source of truth for the LMS design system.
// Curated via the UI/UX Pro Max skill: "LMS" color palette + "Modern Professional" typography.

export const palette = {
  primary: "#0D9488", // teal
  primaryForeground: "#FFFFFF",
  secondary: "#2DD4BF",
  accent: "#D97706", // amber
  accentForeground: "#000000",
  background: "#F0FDFA",
  foreground: "#134E4A",
  card: "#FFFFFF",
  muted: "#E8F1F4",
  mutedForeground: "#475569",
};

export const fonts = {
  heading: "'Poppins', sans-serif",
  body: "'Open Sans', sans-serif",
};

export const antdTheme = {
  token: {
    colorPrimary: palette.primary,
    colorInfo: palette.primary,
    colorLink: palette.primary,
    fontFamily: "Poppins, 'Open Sans', sans-serif",
    fontSize: 14,
    borderRadius: 10,
    colorBgLayout: palette.background,
    colorTextBase: palette.foreground,
    colorTextHeading: palette.foreground,
  },
  components: {
    Button: {
      fontWeight: 600,
      controlHeight: 44,
      primaryShadow: "0 10px 24px -10px rgba(13,148,136,0.55)",
    },
    Card: { borderRadiusLG: 16 },
    Table: { headerBg: palette.muted, headerColor: palette.foreground },
    Modal: { borderRadiusLG: 16 },
  },
};
